@if (showMessage) {
  <div class="error">
    {{ message }}
  </div>
}
@if (!showMessage) {
  <div>&nbsp;</div>
}
